// import React from 'react'
import { FaReact } from 'react-icons/fa';
import { FaPhp } from 'react-icons/fa';
import { FaLaravel } from 'react-icons/fa';
import { FaGitAlt } from 'react-icons/fa6';
import { FaHtml5 } from 'react-icons/fa6';
import { IoLogoJavascript } from 'react-icons/io5';
import { SiMysql } from 'react-icons/si';
import { AiOutlineDotNet } from 'react-icons/ai';
import { BiLogoTailwindCss } from 'react-icons/bi';
import { DiScrum } from 'react-icons/di';
import { SiTypescript } from 'react-icons/si';
import { SiAngular } from 'react-icons/si';
import { SiIonic } from 'react-icons/si';
//  import { FaBootstrap } from 'react-icons/fa';
// import { BsBootstrap } from 'react-icons/bs';
import { SiJira } from 'react-icons/si';
import { FaJava } from 'react-icons/fa';
import { TbBrandCSharp } from 'react-icons/tb';
import { FaCss3Alt } from 'react-icons/fa';

export const Skills = () => {
    return (
        <section className='text-white bg-color-gray flex flex-col justify-center place-items-center gap-3 py-10 border-2 border-color-gray'>

            <article className='col-span-4'>
                <h2 className='text-3xl font-semibold text-green-800 mb-3 text-center'>SKILLS & TOOLS</h2>
            </article>

            <article className='flex flex-col w-[90%] text-6xl bg-color-dark gap-10 py-12 rounded-lg border-2 border-color-gray'>

                <div className='flex flex-col justify-evenly gap-10'>

                    <span className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 flex-wrap items-center px-4'>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <FaPhp className=' text-purple-800' />
                            <p className='text-4xl'>Php</p>
                        </span>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <FaLaravel className=' text-red-600' />
                            <p className='text-3xl'>Laravel</p>
                        </span>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <SiMysql className='' />
                            <p className='text-4xl'>Sql</p>
                        </span>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <AiOutlineDotNet className=' text-purple-500' />
                            <p className='text-4xl'>.NET</p>
                        </span>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5 lg:col-start-2'>
                            <TbBrandCSharp className='text-purple-600' />
                            <p className='text-4xl'>C#</p>
                        </span>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <FaJava className='text-orange-600' />
                            <p className='text-4xl'>Java</p>
                        </span>

                    </span>

                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 flex-wrap items-center justify-evenly px-4'>
                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <FaReact className=' text-blue-500' />
                            <p className='text-4xl'>React</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <SiAngular className='text-pink-800' />
                            <p className='text-4xl'>Angular</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <FaHtml5 className=' text-orange-700' />
                            <p className='text-4xl'>Html5</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <SiIonic className=' text-blue-600' />
                            <p className='text-4xl'>Ionic</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <SiTypescript className=' text-blue-500' />
                            <p className='text-2xl'>TypeScript</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5'>
                            <IoLogoJavascript className=' text-yellow-300' />
                            <p className='text-2xl'>JavaScript</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5 '>
                            <BiLogoTailwindCss className=' text-blue-500' />
                            <p className='text-2xl'>Tailwind</p>
                        </span>

                        <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5 '>
                            <FaCss3Alt className=' text-blue-500' />
                            <p className='text-4xl'>CSS</p>
                        </span>

                    </div>

                </div>

                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4  flex-wrap items-center justify-evenly px-4'>
                    <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5 xl:col-start-2'>
                        <FaGitAlt className=' text-red-600' />
                        <p className='text-4xl'>Git</p>
                    </span>

                    <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5 '>
                        <SiJira className=' text-blue-600' />
                        <p className='text-4xl'>Jira</p>
                    </span>


                    <span className='grid grid-cols-2 justify-items-center items-center gap-3 bg-color-ligth-dark px-3 py-5 sm:col-start-1 sm:col-end-3 md:col-span-1'>
                        <DiScrum className='text-orange-400 ' />
                        <p className='text-4xl'>Scrum</p>
                    </span>

                </div>

            </article>

        </section>
    )
}

export default Skills